import {
  Box,
  Divider,
  Typography
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import React from 'react'

export const InfoItem = ({
  icon,
  label,
  value
}: {
  icon: any
  label: string
  value: string
}) => {
  const classes = useStyles()
  return (
    <div className={classes.infoItem}>
      <div className={classes.iconContainer}>{icon}</div>
      <Box flex={1}>
        <Typography className={classes.label}>{label}</Typography>
        <Typography className={classes.value}>{value}</Typography>
        <Divider className={classes.divider} />
      </Box>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(1)
  },
  infoItem: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2)
  },
  iconContainer: {
    backgroundColor: '#f0f0f0',
    borderRadius: '50%',
    padding: theme.spacing(1),
    marginRight: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#9e9e9e'
  },
  label: {
    fontWeight: 600,
    color: '#424242',
    fontSize: '0.9rem'
  },
  value: {
    color: '#757575',
    fontSize: '0.85rem'
  },
  divider: {
    margin: theme.spacing(1, 0),
    backgroundColor: '#e0e0e0'
  }
}))
